import GlobalArrowSVG from "../../../../../svgs/GlobalArrowSVG";
import InternetPayment from "../../../../../pngs/InternetPayment.png";
import FileNotification from "../../../../../pngs/FileNotification.png";
import Calculation from "../../../../../pngs/Calculation.png";
import JudicalAppointment from "../../../../../pngs/JudicalAppointment.png";
import JudiciarySystem from "../../../../../pngs/JudiciarySystem.png";
import ListOfJudicial from "../../../../../pngs/ListOfJudicial.png";
import ENSystem from "../../../../../pngs/ENSystem.png";
import LawyerInquiry from "../../../../../pngs/LawyerInquiry.png";
import LawyersSystem from "../../../../../pngs/LawyersSystem.png";
import MoriButton from "../../../../systemDesign/Buttons/MoriButton";
import Pin from "../../../../systemDesign/Sep/Pin";
import QuickCard from "./Cards/QuickCard";

const QuickAccess = () => {
  return (
    <div className="w-full relative flex flex-col items-center gap-2 mt-4 lg:pt-10 lg:mt-6 border-t border-stroke1 lg:pl-10">
      <h4 className="flex items-center gap-1 lg:gap-3 text-text2 text-[10px] sm:text-[13px] lg:text-[16px] xl:text-[20px] mt-10">
        <GlobalArrowSVG className="w-[10px] md:scale-110 lg:scale-125 xl:scale-150 txl:scale-[200%]" />{" "}
        www.adliran.ir
      </h4>
      <h3 className="text-subColor5 text-[13px] mini:text-[16px] md:text-[25px] lg:text-[30px] xl:text-[36px] flex items-center mb-5 md:mb-10 xl:mb-20 gap-2 lg:gap-4">
        Quick access to
        <MoriButton
          text="judicial"
          textCustomClass="!text-subColor5 !text-[10px] md:!text-[14px] lg:!text-[16px] !ml-0 !top-[-1px]"
          customClass="!w-[57px] !h-[20px] md:!w-[80px] md:!h-[30px] lg:scale-110 !flex !items-center !justify-center !bg-transparent rounded-full border border-subColor5 !cursor-default relative !top-[2px] xl:!top-1"
        />
        service links.
      </h3>
      <div className="w-full flex items-center justify-between px-2 min-[420px]:px-5 md:px-10">
        <div className="w-[35%] relative h-full border-r border-stroke1 flex flex-col justify-around gap-3 md:gap-5 lg:gap-8 txl:gap-14 pb-3 lg:pb-16 lg:h-[300px]">
          <QuickCard className="scale-[45%] relative right-14">
            <img src={InternetPayment} alt="" />
          </QuickCard>
          <QuickCard>
            <img src={FileNotification} alt="" />
          </QuickCard>
          <QuickCard>
            <img src={Calculation} alt="" />
          </QuickCard>
          <Pin className="-right-[10.3px] top-[10px] scale-75 md:scale-100 md:top-[20px] lg:top-[50px]" />
          <Pin className="-right-[10.3px] top-[45px] scale-75 md:scale-100 md:top-[60px] lg:top-[160px]" />
        </div>
        <div className="w-[38%] relative h-full border-r border-stroke1 flex flex-col justify-around pl-1 mini:pl-2 md:pl-5 gap-3 md:gap-5 lg:gap-8 txl:gap-14 pb-3 lg:pb-16 lg:h-[300px]">
          <QuickCard className="top-1">
            <img src={JudicalAppointment} alt="" />
          </QuickCard>
          <QuickCard>
            <img src={JudiciarySystem} alt="" />
          </QuickCard>
          <QuickCard>
            <img src={ListOfJudicial} alt="" />
          </QuickCard>
          <Pin className="-right-[10.3px] top-[10px] scale-75 md:scale-100 md:top-[20px] lg:top-[50px]" />
          <Pin className="-right-[10.3px] top-[45px] scale-75 md:scale-100 md:top-[60px] lg:top-[160px]" />
        </div>
        <div className="w-[26%] h-full flex flex-col justify-around pl-1 mini:pl-2 md:pl-5 gap-3 md:gap-5 lg:gap-8 txl:gap-14 pb-3 lg:pb-16 lg:h-[300px]">
          <QuickCard>
            <img src={ENSystem} alt="" />
          </QuickCard>
          <QuickCard>
            <img src={LawyerInquiry} alt="" />
          </QuickCard>
          <QuickCard>
            <img src={LawyersSystem} alt="" />
          </QuickCard>
        </div>
      </div>
    </div>
  );
};

export default QuickAccess;
